export default __webpack_public_path__ + "static/media/thumbnail.eb9d5d62.svg";